"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-15 09:33:17
 * @Desc: 节点
 */
var _default2 = exports.default = {
  name: 'SFCNode',
  props: {
    nodeList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    childrenList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    data: {
      type: Object,
      default: null
    },
    belongConditionNodeData: {
      type: Object,
      default: null
    },
    isMouseEnter: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isCurrentMouseEnter: false
    };
  },
  methods: {
    onMouseenter: function onMouseenter() {
      this.isCurrentMouseEnter = true;
    },
    onMouseleave: function onMouseleave() {
      this.isCurrentMouseEnter = false;
    }
  }
};